import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, Button, Typography, Breadcrumbs, Link } from "@mui/material";
import { makeStyles } from "@mui/styles";

import EditIcon from "../../assets/images/edit-icon-white.svg";
import EditableTextField from "../../components/EditableTextField";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(3)} ${theme.spacing(4.5)} ${theme.spacing(1.5)}`,
  },
  heading: {
    fontWeight: 700,
    fontSize: 20,
    letterSpacing: "-4%",
    lineHeight: "24px",
  },
  separator: {
    marginLeft: `${theme.spacing(0.5)} !important`,
    marginRight: `${theme.spacing(0.5)} !important`,
  },
}));

const Header: React.FC<{
  recordingName: string;
  recordingId?: string;
  workflowName: string;
  editMode: number;
  onFlowNameUpdate: (updatedName: string) => void;
  handleEditFlowClick: () => void;
}> = ({
  recordingId,
  recordingName,
  workflowName,
  onFlowNameUpdate,
  editMode,
  handleEditFlowClick,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2.5}
      >
        <Box>
          <FlowBreadcrumb
            recordingId={recordingId}
            recordingName={recordingName}
            flowName={workflowName}
            onFlowNameUpdate={onFlowNameUpdate}
          />
        </Box>
        {editMode === 0 && (
          <Button
            startIcon={
              <img src={EditIcon} alt="create flow" width="14" height="14" />
            }
            variant="contained"
            color="secondary"
            sx={{
              padding: "10px 21px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
              textTransform: "unset !important",
            }}
            onClick={handleEditFlowClick}
            aria-label="Edit Flow"
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                lineHeight: "16px",
              }}
            >
              Edit Flow
            </Typography>
          </Button>
        )}
      </Box>
    </Box>
  );
};

const FlowBreadcrumb: React.FC<{
  recordingName: string;
  recordingId?: string;
  flowName: string;
  onFlowNameUpdate: (value: string) => void;
}> = ({ flowName, recordingId, recordingName, onFlowNameUpdate }) => {
  const classes = useStyles();
  return (
    <Breadcrumbs classes={{ separator: classes.separator }}>
      <Link
        color="inherit"
        to={`/recording/${recordingId}`}
        component={RouterLink}
        underline="none"
      >
        <Typography
          variant="body1"
          color="primary"
          sx={{ textTransform: "capitalize" }}
        >
          {recordingName}
        </Typography>
      </Link>
      <EditableTextField
        value={flowName}
        onSubmit={onFlowNameUpdate}
        className={classes.heading}
      />
    </Breadcrumbs>
  );
};

Header.propTypes = {
  recordingId: PropTypes.string,
  recordingName: PropTypes.string.isRequired,
  workflowName: PropTypes.string.isRequired,
  editMode: PropTypes.oneOf([0, 1, 2]).isRequired,
  onFlowNameUpdate: PropTypes.func.isRequired,
  handleEditFlowClick: PropTypes.func.isRequired,
};

export default Header;
